export const theme = {
    fontS: `13px`,
    fontM: `18px`,
    fontL: `24px`,
    colorAccent: `#33B7AF`,
    colorMain: `#75557A`,
    colorWarning: `#E84545`,
};
